import { Injectable } from "@angular/core";
import { ConfigService } from "../config/config.service";
import { UtilsService } from "../utils/utils.service";
import { CustomerModel } from "src/app/models/customer-model";
import { UserSessionService } from "../user-session/user-session.service";
import { WebservicesService } from "../webservices/webservices.service";
import { EventsService } from "../event/event.service";

@Injectable({
  providedIn: "root",
})

export class LobbyService {

  private isIAB: boolean = false;
  private automationRunning: boolean = false;
  public waitingGameData = null;
  public waitingDialogPage = null;
  public waitingDialogPageParams = null;
  public liveDealerKeywordName = null;
  public restrictedGameData = null;
  public timeOnline: any;
  public subPage;
  public currentLoginTime: Date;
  public gamePopoverOpen: boolean = false;
  public gameSessionToken: any;
  public customer: CustomerModel;
  public galleryImagePath: any;
  private activeTab;

  constructor(
    private utils: UtilsService,
    private config: ConfigService,
    private userSession: UserSessionService,
    private eventsService: EventsService,
    private webservices: WebservicesService,
  ) {
    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    );
    this.galleryImagePath = this.config.getConfig().CDN_BASEURL + '/assets/social/games/';  //main image path
    this.eventsService.subscribe("event:config:reload", () => {
      this.config.isLoaded().then(() => {
        this.setGalleryImagePath();
      });
    });
  }

  saveActiveTab(tabName) {
    this.activeTab = tabName;
  }

  currentActiveTab() {
    return (!!this.activeTab) ? this.activeTab : 'CASINO';
  }

  private setGalleryImagePath() {
    this.galleryImagePath = this.config.getConfig().CDN_BASEURL + '/assets/social/games/';
  }

  clearWaitingGameData() {
    this.waitingGameData = null;
  }

  // Setters implementation pending
  isIABApp(): boolean {
    return this.isIAB;
  }

  getWaitingGameData() {
    return this.waitingGameData;
  }

  getWaitingDialogPage() {
    return this.waitingDialogPage;
  }

  setWaitingGameData(data) {
    this.waitingGameData = data;
  }

  setWaitingDialogPage(page) {
    this.waitingDialogPage = page;
  }

  setWaitingDialogPageParams(params) {
    this.waitingDialogPageParams = params;
  }

  getWaitingDialogPageParams() {
    return this.waitingDialogPageParams;
  }

  clearWaitingDialogPageParams() {
    this.waitingDialogPageParams = null;
  }

  //Restricted Game Data
  setRestrictedGameData(id) {
    this.restrictedGameData = id;
  }

  getRestrictedGameData() {
    return this.restrictedGameData;
  }

  clearRestrictedGameData() {
    this.restrictedGameData = null;
  }

  clearWaitingDialogPage() {
    this.waitingDialogPage = null;
  }

  setGamePopoverState(state: boolean) {
    this.gamePopoverOpen = state;
  }

  setCurrentLoginTime(currentLoginTime: Date) {
    this.currentLoginTime = currentLoginTime;
  }

  getCurrentLoginTime() {
    return this.currentLoginTime;
  }

  setGameSessionID(game_token) {
    this.gameSessionToken = game_token;
  }

  getGameSessionID() {
    return this.gameSessionToken;
  }

  clearGameSessionID() {
    this.gameSessionToken = null;
  }

  getLiveDealerUrl(isMobile, liveDealerCategoryLaunch?, vendorName?) {
    let obj: any = {
      customer_id: this.customer?.customerId ?? null,
      session_token: this.userSession?.sessionToken ?? null,
      vendor: vendorName ? vendorName : "evolution",
      clientapp: this.config.getClientApp(),
      noredirect: "1",
      is_mobile: isMobile,
    }

    if (!!liveDealerCategoryLaunch) obj.category = liveDealerCategoryLaunch;

    return this.webservices.get('games/launch-lobby', obj)
  }

  setAutomationRunning(isRunning: boolean) {
    this.automationRunning = isRunning;
  }

  isAutomationRunning(): boolean {
    return this.automationRunning;
  }

  setLiveDealerKeywordName(name) {
    this.liveDealerKeywordName = name;
  }

  getLiveDealerKeywordName() {
    return this.liveDealerKeywordName;
  }
}
